import {Component, inject, OnInit} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {Translation} from '../../../models/translation';
import {Client, LogisticsOrder, LogisticsOrderResponse} from '../../../models/models';
import {LoginService} from '../../../services/login.service';
import {CheckService} from '../../../services/check.service';
import {MulesoftService} from '../../../services/mulesoft.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-logistics-task',
  templateUrl: './logistics-task.component.html',
  styleUrls: ['./logistics-task.component.css']
})
export class LogisticsTaskComponent implements OnInit {

  // Service injections
  private readonly loginService: LoginService = inject(LoginService);
  private readonly checkService: CheckService = inject(CheckService);
  private readonly mulesoftService: MulesoftService = inject(MulesoftService);

  // Public properties
  public translation: Translation;
  public userData: Client;
  public currentOrderIndex = 0;
  public processIds: string[] = sessionStorage.getItem('ProcessIds').split(';');
  public logisticsOrders: LogisticsOrder[] = [this.newOrder(0)];
  public currentOrder: LogisticsOrder = this.logisticsOrders[0];
  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  // Init
  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkModule(55);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.fillUserData();
  }

  addNewOrder() {
    const newOrder: LogisticsOrder = this.newOrder(this.logisticsOrders.length);
    this.logisticsOrders.push(newOrder);
    this.currentOrderIndex = this.logisticsOrders.length - 1;
  }

  removeOrder() {
    // Remove from array by filtering
    this.logisticsOrders = this.logisticsOrders.filter(o => o.index !== this.currentOrderIndex);
    // Rewrite all indexes after deletion
    for (let i = 0; i < this.logisticsOrders.length; i++) {
      this.logisticsOrders[i].index = i;
    }
    // Go to last index
    this.currentOrderIndex = this.logisticsOrders.length - 1;
  }

  validate(order: LogisticsOrder) {
    if (order.vin === '') { order.message = this.translation.ChassisNumber + ' - ' + this.translation.MustBeFilled; return true; }
    if (order.make === '') { order.message = this.translation.Brand + ' - ' + this.translation.MustBeFilled; return true; }
    if (order.model === '') { order.message = this.translation.Model + ' - ' + this.translation.MustBeFilled; return true; }
    if (order.vin.length !== 17) { order.message = this.translation.ChassisNumber + ' - ' + this.translation.MustBeSeventeenDigits; return true; }
    return false;
  }

  sendAllOrders() {
    // Loop orders
    this.logisticsOrders.forEach(order => {
      // Ignore already confirmed orders
      if (order.status !== 2) {
        // Validate inputs of this order
        const hasErrors = this.validate(order);
        if (!hasErrors) {
          this.sendSingleOrder(order, false);
        } else {
          order.status = 1;
        }
      }
    });
  }

  sendSingleOrder(order: LogisticsOrder, validate: boolean) {
    const hasErrors = validate ? this.validate(order) : false;
    if (!hasErrors) {
      this.mulesoftService.sendLogisticsOrder(this.convertLogisticsOrderToLogisticsOrderRequest(order)).subscribe({
        // Handle success
        next: ((response: LogisticsOrderResponse): void => {
          order.status = response.status === 'successful' ? 2 : 1;
          order.message = response.details;
          order.orderNumber = response.orderNumber;
        }),
        // Handle error
        error: ((error: HttpErrorResponse): void => {
          order.status = 1;
          order.message = 'Der Dienst steht momentan nicht zur Verfügung. Bitte probieren Sie es später noch einmal.';
          console.log(error);
        })
      });
    }
  }

  newOrder(index: number) {
    return {
      index,
      primaryInvoiceRecipientId: JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid,
      orderingAccountId: JSON.parse(sessionStorage.getItem('PrimaryAddress')).PartnerAid,
      orderSource: sessionStorage.getItem('OrderSource'),
      orderType: 'Logistik',
      processId: this.processIds[0],
      customerReference: '',
      vin: '',
      make: '',
      model: '',
      message: '',
      status: 0,
      orderNumber: null
    };
  }

  convertLogisticsOrderToLogisticsOrderRequest(order: LogisticsOrder) {
    return {
      primaryInvoiceRecipient: {
        id: order.primaryInvoiceRecipientId
      },
      orderingAccount: {
        id: order.orderingAccountId
      },
      orderSource: order.orderSource,
      orderType: order.orderType,
      processId: order.processId,
      customerReference: order.customerReference,
      vehicle: {
        vin: order.vin,
        make: order.make,
        model: order.model,
      }
    };
  }

  changeTab($event: number) {
    this.currentOrderIndex = $event;
    this.currentOrder = this.logisticsOrders[$event];
  }

  fillUserData() {
    this.userData = new Client();
    this.userData.Name = JSON.parse(sessionStorage.getItem('PrimaryAddress')).Description;
    this.userData.Contact = sessionStorage.getItem('FirstName') + ' ' + sessionStorage.getItem('LastName');
    this.userData.Email = sessionStorage.getItem('Email');
    this.userData.Phone = sessionStorage.getItem('Phone');
    this.userData.AddressLine1 = JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryStreet;
    this.userData.AddressLine2 = JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryAddition;
    this.userData.Zip = +JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryZip;
    this.userData.City = JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryCity;
    this.userData.Region = JSON.parse(sessionStorage.getItem('PrimaryAddress')).DeliveryRegion;
  }
}
